// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { EmbedContent } from '../../Embed.contracts'

/**
 * Component capable of rendering the `EmbedModule`
 * with the version set to `EmbedVersion.Iframe`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'EmbedIframeUi',
  mounted () {
    this.$emit('ready')
  },
  template: `
    <figure>
      <div v-html="html" />
      <figcaption v-if="description" class="small">{{ description }}</figcaption>
    </figure>
  `
})
export class EmbedIframeUi extends Vue {
  /**
   * Additional description of the embedded content.
   */
  @Prop({ type: String, required: false })
  public readonly description?: EmbedContent['description']

  /**
   * The `<iframe>` element to render.
   */
  @Prop({ type: String, required: true })
  private readonly iframe!: EmbedContent['iframe']

  /**
   * Protects you from accessing an undefined variable.
   *
   * @returns - `this.iframe` if it exists
   * @returns - Empty string, if this.iframe hasn't been defined or is broken.
   */
  public get html (): string {
    return typeof this.iframe === 'string' && this.iframe.length > 0
      ? this.iframe
      : ''
  }
}
